export async function mapWithConcurrency(items, limit, worker, onSettled) {
  if (!items || items.length === 0) return [];

  const results = new Array(items.length).fill(null);
  let cursor = 0;

  const runner = async () => {
    while (cursor < items.length) {
      const i = cursor++;
      let value = null;
      try {
        value = await worker(items[i], i);
      } catch {
        value = null;
      }
      results[i] = value;
      if (onSettled) {
        try {
          onSettled(items[i], i, value);
        } catch {
          // onSettled must never abort the batch — mapWithConcurrency never rejects.
        }
      }
    }
  };

  const poolSize = Math.max(0, Math.min(limit, items.length));
  await Promise.all(Array.from({ length: poolSize }, runner));

  return results;
}
